export default __webpack_public_path__ + "static/media/GroupedBarChartBlue.22e6e1f1.svg";